import React, { useEffect, useState } from "react";
import { View, TouchableOpacity } from "react-native";

import Modal from "./Modal";
import Text from "components/Text";
import Icon from "components/Icon";
import Input from "components/Input";
import Empty from "components/Empty";
import Error from "components/Error";
import Loading from "components/Loading";
import AnimatedInfinityList from "components/AnimatedInfinityList";

import { styles } from "./styles";
import { sizes, colors, strings } from "assets/constants";

import { useFlag } from "hooks";
import { liveSearchInput, mq } from "utils";

import { useCountries } from "clients/apis";
import ModalInfinityList from "components/ModalInfinityList";

let timer: ReturnType<typeof setTimeout>;

export default function CountryPicker(props: PickerT) {
  const { value, onSelect, error, hideError } = props;
  const val = value as LocationT;

  const [name, setName] = useState("");
  const {
    isError,
    error: countriesError,
    isRefetching,
    refetch,
    isLoading: countriesLoading,
    data: countries,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useCountries({ name });

  const { flg: modal, on: show, off: hide } = useFlag();
  const { flg: typing, on: startTyping, off: stopTyping } = useFlag();

  const [valueState, setValueState] = useState<LocationT | undefined>();

  useEffect(() => {
    setValueState(val);
  }, [val]);

  const _renderItem = (items: []) => {
    return items.map((country: LocationT, key: number) => (
      <React.Fragment key={String(key)}>
        <TouchableOpacity
          style={styles.item}
          onPress={() => {
            onSelect && onSelect(country);
            setName("");
            setValueState(country);
            hide();
          }}
        >
          <Text>{country.text}</Text>
        </TouchableOpacity>
        <View style={styles.itemSeparator} />
      </React.Fragment>
    ));
  };

  const _renderList = () => {
    if (countriesLoading || typing) {
      return <Loading style={{ marginTop: mq(20) }} />;
    }

    if (isError) {
      return (
        <Error error={countriesError} reset={refetch} loading={isRefetching} />
      );
    }

    if (countries?.pages?.[0]?.data?.data?.length === 0) {
      return <Empty message={strings.no_country} />;
    }

    return (
      <AnimatedInfinityList
        onRefresh={refetch}
        responseData={countries}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        renderItemList={_renderItem}
      />
    );
  };

  return (
    <>
      <>
        <TouchableOpacity
          onPress={show}
          activeOpacity={sizes.tapOpacity}
          style={{ ...styles.container }}
        >
          <View style={styles.iconContainer}>
            <Icon name="chevron-down" />
          </View>
          <View style={styles.textContainer}>
            <Text
              color={
                valueState?.text ? colors.textColorDefault : colors.placeholder
              }
            >
              {valueState?.text || strings.pick_country}
            </Text>
          </View>

          <View style={styles.iconContainer}>
            <Icon name="map-pin" />
          </View>
        </TouchableOpacity>

        {!hideError && (
          <View style={styles.errorContainer}>
            <Text size={"xs"} color={colors.danger}>
              {error}
            </Text>
          </View>
        )}
      </>

      <ModalInfinityList close={hide} visible={modal}>
        <View style={styles.listSearchContainer}>
          <Input
            hideError
            icon={{ name: "search" }}
            placeholder={strings.search}
            onChangeText={(inputName) => {
              liveSearchInput(
                inputName,
                name,
                setName,
                timer,
                startTyping,
                stopTyping
              );
            }}
          />
        </View>
        {_renderList()}
      </ModalInfinityList>
    </>
  );
}
